import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi, baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import config from "../config";
class CashierCollectionReportStore {

    total = 0
    cashierAllData = []
    adjustedTripData = []
    getUsersUsingCompanyId = []
    rootStore
    loading = false

    constructor(rootStore) {
        makeObservable(this, {
        total: observable,
        cashierAllData: observable,
        loadData: action,
        loading: observable
        });
        this.rootStore = rootStore;

    }

    async getCashierUser(companyId) {

        var postData = {
            companyId: companyId,
        };
        
        var response = await postApi.getClient().get(config.NodeUrl + "/cashier/getCashierUser", { params: postData });
        // var response = await postApi.getClient().get("http://localhost:4000/cashier/getCashierUser", { params: postData });
        
        this.getUsersUsingCompanyId = response?.data?.data;

        return response?.data?.data;
    }



    async loadData({ companyId, userId, fromDate, toDate, offset, limit,pageNo }) {

      this.loading = true
      
      var postData = {
        companyId: companyId,
        userId: userId,
        fromDate: fromDate,
        toDate: toDate,
        offset: offset,
        limit: limit,
        page: pageNo,
      };

      var response = await postApi.getClient("report").get("cashier/getCashierReportData", { params: postData });
      // var response = await postApi.getClient().get("http://localhost:4000/cashier/getCashierReportData", { params: postData });
            
      this.cashierAllData = response?.data?.data;
      this.cashierInnerGridData= response?.data?.data.map((items)=>items.tableData);
      
      this.total = response?.data?.TotalCount;
      this.loading = false

    }

    async getAdjustedTrips(postData) {

      this.loading = true

      var response = await postApi.getClient("report").get("cashier/getAdjustedTrips", { params: postData });
      // var response = await postApi.getClient().get("http://localhost:4000/cashier/getAdjustedTrips", { params: postData });
            
      this.adjustedTripData = response?.data?.data || [];     
      this.loading = false

      return response?.data?.data

    }

    async exportExcel(getData) {

      try {

        var response = await postApi
          .getClient("")
          // .post("http://localhost:4000/cashier/exportCashierExcel", getData, {
          //   responseType: "blob",
          // });
          .post(config.NodeUrl + "/cashier/exportCashierExcel", getData, {
            responseType: "blob",
          });
        
        const blob = new Blob(
          [response.data],
          {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }
        );

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Cashier_Collection.xlsx";
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.log(error)
      }
         
    }

    async exportpdf(getData) {
      try {
        const response = await postApi
          .getClient("")
          // .post("http://localhost:4000/cashier/exportCashierPdf", getData, {
          //   responseType: "blob",
          // });
          .post(config.NodeUrl + "/cashier/exportCashierPdf", getData, {
            responseType: "blob",
          });

        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Cashier_Collection.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
      }
    }
  
}

export default CashierCollectionReportStore;
